var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08366 12.0719C7.08366 13.1458 7.95422 14.0164 9.0281 14.0164H10.8337C11.9843 14.0164 12.917 13.0836 12.917 11.933C12.917 10.7824 11.9843 9.84969 10.8337 9.84969H9.16699C8.0164 9.84969 7.08366 8.91695 7.08366 7.76636C7.08366 6.61576 8.0164 5.68302 9.16699 5.68302H10.9725C12.0464 5.68302 12.917 6.55358 12.917 7.62747M10.0003 4.43302V5.68302M10.0003 14.0164V15.2664M18.3337 9.84969C18.3337 14.4521 14.6027 18.183 10.0003 18.183C5.39795 18.183 1.66699 14.4521 1.66699 9.84969C1.66699 5.24732 5.39795 1.51636 10.0003 1.51636C14.6027 1.51636 18.3337 5.24732 18.3337 9.84969Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalary);
export default __webpack_public_path__ + "static/media/salary.ae12077496529eeafa4b93ec3ff368e1.svg";
export { ForwardRef as ReactComponent };